export const subDocFailureTable = 'subDocFailures';
